export const CONFIG_SETUP_ROUTES = {
  index: {
    path: 'config-setup/*',
    to: '/config-setup',
  },
  setupFirstUser: {
    path: 'setup_first',
    to: '/config-setup/setup_first',
  },
  setupFirst: {
    path: 'setup_first/:id',
    to: (id: string) => `/config-setup/setup_first/${id}`,
  },
  discovery: {
    path: 'discovery/:id',
    to: (id: string) => `/config-setup/discovery/${id}`,
  },

  setupSecond: {
    path: 'setup_second/:id',
    to: (id: string) => `/config-setup/setup_second/${id}`,
  },
  setupPlant: {
    path: 'setup-plant',
    to: '/config-setup/setup-plant',
  },
  setupSoil: {
    path: 'setup-soil',
    to: '/config-setup/setup-soil',
  },
  setupEmitter: {
    path: 'setup-emitter',
    to: '/config-setup/setup-emitter',
  },
  setupEtReference: {
    path: 'setup-etReference',
    to: '/config-setup/setup-etReference',
  },
  setupEtZone: {
    path: 'setup-etZone',
    to: '/config-setup/setup-etZone',
  },
  setupAreas: {
    path: 'setup-Areas',
    to: '/config-setup/setup-Areas',
  },

  sites: {
    path: 'sites',
    to: '/config-setup/sites',
  },
  sitesCommon: {
    path: 'common-sites',
    to: '/config-setup/common-sites',
  },
  dataSites: {
    path: 'data-sites',
    to: '/config-setup/data-sites',
  },

  pipes: {
    path: 'pipes',
    to: '/config-setup/pipes',
  },
  pipesCommon: {
    path: 'common-pipes',
    to: '/config-setup/common-pipes',
  },
  dataPipes: {
    path: 'data-pipes',
    to: '/config-setup/data-pipes',
  },

  pump: {
    path: 'pump',
    to: '/config-setup/pump',
  },
  pumpCommon: {
    path: 'common-pump',
    to: '/config-setup/common-pump',
  },
  dataPump: {
    path: 'data-pump',
    to: '/config-setup/data-pump',
  },

  plant: {
    path: 'plant',
    to: '/config-setup/plant',
  },
  plantCommon: {
    path: 'common-plant',
    to: '/config-setup/common-plant',
  },
  dataPlant: {
    path: 'data-plant',
    to: '/config-setup/data-plant',
  },

  soil: {
    path: 'soil',
    to: '/config-setup/soil',
  },
  soilCommon: {
    path: 'common-soil',
    to: '/config-setup/common-soil',
  },
  dataSoil: {
    path: 'data-soil',
    to: '/config-setup/data-soil',
  },

  historical: {
    path: 'historical',
    to: '/config-setup/historical',
  },

  historicalCommon: {
    path: 'common-historical',
    to: '/config-setup/common-historical',
  },

  dataHistorical: {
    path: 'data-historical',
    to: '/config-setup/data-historical',
  },

  emitter: {
    path: 'emitter',
    to: '/config-setup/emitter',
  },

  emitterCommon: {
    path: 'common-emitter',
    to: '/config-setup/common-emitter',
  },
  dataEmitter: {
    path: 'data-emitter',
    to: '/config-setup/data-emitter',
  },

  sensor: {
    path: 'sensor',
    to: '/config-setup/sensor',
  },
  sensorCommon: {
    path: 'common-sensor',
    to: '/config-setup/common-sensor',
  },
  dataSensor: {
    path: 'data-sensor',
    to: '/config-setup/data-sensor',
  },

  et: {
    path: 'et',
    to: '/config-setup/et',
  },
  etCommon: {
    path: 'common-et',
    to: '/config-setup/common-sensor',
  },
  dataET: {
    path: 'data-et',
    to: '/config-setup/data-et',
  },

  setupThird: {
    path: 'setup_third',
    to: '/config-setup/setup_third',
  },
  station: {
    path: 'station',
    to: '/config-setup/station',
  },
  stationCommon: {
    path: 'common-station',
    to: '/config-setup/common-station',
  },
  dataStation: {
    path: 'data-station',
    to: '/config-setup/data-station',
  },
  setupFour: {
    path: 'setup_four',
    to: '/config-setup/setup_four',
  },
  stationAssignment: {
    path: 'station-assignment',
    to: '/config-setup/station-assignment',
  },
  stationAssignmentCommon: {
    path: 'common-station_assignment',
    to: '/config-setup/common-station_assignment',
  },
  dataStationAssignment: {
    path: 'data-station_assignment',
    to: '/config-setup/data-station_assignment',
  },
  setupFinish: {
    path: 'setup_finish',
    to: '/config-setup/setup_finish',
  },
}
